import { GlobalController } from 'src/shared/global/GlobalController'
import IndustryAccount from './IndustryAccountPage.vue'
import IndustryDashboard from './IndustryDashboard.vue'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: 'industry-dashboard',
    name: 'industryDashboard',
    component: IndustryDashboard,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: ':link',
    name: 'industryAccount',
    component: IndustryAccount,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
